module.exports = __webpack_public_path__ + "static/oak-45dbdf1a1dcf4cc13b549e6325fb6c47.jpg";